import React from 'react';

const ArrayError = ({ invalid, submitFailed, error }) => {
  if (invalid && submitFailed) return (
    <span>{error}</span>
  )
  return false;
}

export default ArrayError;


// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/ArrayError.js